var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4922 13.2578V14.7375C27.4922 16.2464 26.2656 17.473 24.7567 17.473H17.4651V24.7596C17.4651 26.2686 16.2385 27.4854 14.7296 27.4854H13.2499C11.741 27.4854 10.5144 26.2637 10.5144 24.7596V17.473H3.22772C1.71879 17.473 0.492188 16.2464 0.492188 14.7375V13.2578C0.492188 13.0485 0.52139 12.8343 0.565197 12.6396C0.842644 11.4276 1.92811 10.5271 3.22286 10.5271H10.5095V3.24045C10.5095 1.73152 11.7361 0.514648 13.245 0.514648H14.7248C16.2337 0.514648 17.4603 1.73639 17.4603 3.24045V10.5271H24.7518C26.2607 10.5271 27.4873 11.7488 27.4873 13.2626L27.4922 13.2578Z",
    fill: "#F5A800"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.15f754c4b47660735c16547226f9b7f2.svg";
export { ForwardRef as ReactComponent };